<template>
  <div class="box header">
    <div class="fiex">
      <div class="box-all">
        <div class="title">
          <span v-if="!name" @click="popUps(0)">Войти</span>
          <span v-else>{{ name }}</span>
          <span v-if="!name" @click="popUps(1)" class="active"
            >Регистрация</span
          >
          <span v-else @click="open">выход</span>
          <span @click="popUps(2)">Заказы</span>
          <span @click="popUps(3)">Мои данные</span>
        </div>
        <div class="searching-feature">
          <img
            @click="goHref(1)"
            class="logo"
            src="../assets/images/img_logo.png"
            alt=""
          />
          <div class="search-for">
            <img src="../assets/images/searchbar_icon_search.png" alt="" />
            <div class="search-input-box">
              <input v-model="search" type="text" placeholder="Искать" />
            </div>
            <div class="search-button" @click="searchFor">
              <span>Искать</span>
            </div>
          </div>

          <div class="shopping-cart" @click="goHref(2)">
            <div class="shopping-cart-button">
              <img src="../assets/images/gouwuche.png" alt="" /><span
                >Корзина</span
              >
            </div>
            <span
              v-if="total_num != 0 && total_num != '' && total_num != undefined"
              class="unread-number"
              >{{ total_num }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      width="600px"
      class="dialog"
      :visible.sync="dialogTableVisible"
      :closeOnClickModal="false"
    >
      <img class="logo" src="../assets/images/img_logo.png" alt="" />
      <p class="title">Вход пароля</p>
      <div class="text-box">
        <img src="../assets/images/login_icon_mobile.png" alt="" />+
        <span class="qi">7</span>
        <input
          maxlength="14"
          placeholder="Тел"
          v-model="phoneNumber_1"
          @keyup.delete="jianting"
          v-on:keyup.enter="login"
        />
      </div>
      <div class="text-box">
        <img src="../assets/images/login_icon_password.png" alt="" />
        <el-input
          v-on:keyup.enter.native="login"
          placeholder="Пароль"
          v-model="password"
          show-password
        />
      </div>
      <div class="button">
        <el-button type="warning" size="medium" :loading="false" @click="login"
          >Войти</el-button
        >
      </div>

      <!-- <p class="features"> -->
      <!-- <div class="features"> -->
      <div class="right" @click="registeredFun">Создать аккаунт ></div>
      <!-- </div> -->
      <!-- </p> -->
      <!-- <el-button type="warning">警告按钮</el-button> -->
    </el-dialog>
    <el-dialog
      width="600px"
      class="forgot"
      :visible.sync="forgotVisible"
      :closeOnClickModal="false"
    >
      <p class="title">Восстановить пароль</p>
      <div class="text-box">
        <img src="../assets/images/login_icon_mobile.png" alt="" />+<span
          class="qi"
          >7</span
        ><input placeholder="Тел" maxlength="14" v-model="phoneNumber_2" />
      </div>
      <div class="text-box">
        <img src="../assets/images/login_icon_verifycode.png" alt="" /><input
          placeholder="Кода SMS"
          v-model="retrievePasswordCode"
        />
        <span class="duanxin" @click="smsCode(2, 2)" ref="retrieve">{{
          secondCode_2 == 60 ? "Получить кода SMS" : secondCode_2
        }}</span>
      </div>
      <div class="text-box">
        <img src="../assets/images/login_icon_password.png" alt="" /><input
          type="passWord"
          placeholder="Пароль"
          v-model="pleaseEnterTheLoginPassword"
        />
      </div>
      <div class="text-box">
        <img src="../assets/images/login_icon_password.png" alt="" /><input
          type="passWord"
          placeholder="Еще раз Пароль"
          v-model="retrieveThePasswordAgain"
        />
      </div>
      <div class="button">
        <el-button
          type="warning"
          size="medium"
          :loading="false"
          @click="determineModification"
          >Подтвердите изменения
        </el-button>
      </div>

      <!-- <p class="features"> -->
      <!-- <div class="features"> -->
      <p class="left" @click="returnToLogin">&lt; Вход пароля ></p>
      <!-- </div> -->
      <!-- </p> -->
      <!-- <el-button type="warning">警告按钮</el-button> -->
    </el-dialog>
    <el-dialog
      width="900px"
      class="registered"
      :visible.sync="registered"
      :closeOnClickModal="false"
    >
      <p class="title">Регистрация</p>
      <div class="text-box t1">
        <img src="../assets/images/login_icon_mobile.png" alt="" />
        <span class="jia">+</span><span class="qi"> 7</span
        ><input placeholder="Тел" v-model="phoneNumber_3" maxlength="14" /><span
          class="asterisk"
          >*</span
        >
      </div>
      <!-- <div class="text-box"> -->
        <div>
        <!-- <img src="../assets/images/login_icon_verifycode.png" alt="" /><input
          placeholder="Кода SMS"
          v-model="registerVerificationCode"
        />
        <span class="duanxin" @click="smsCode(1, 1)" ref="retrieve2">{{
          secondCode == 60 ? "Получить кода SMS" : secondCode
        }}</span> -->
      </div>
      <div class="text-box t1">
        <img src="../assets/images/login_icon_password.png" alt="" /><input
          placeholder="Пароль"
          v-model="signUpPassword"
          type="password"
        />
      </div>
      <div class="text-box">
        <img src="../assets/images/login_icon_password.png" alt="" /><input
          type="passWord"
          placeholder="Еще раз Пароль"
          v-model="registerAgain"
        />
      </div>
      <div class="d2">
        <p>Имя <span style="color: red">*</span></p>
        <div class="text-box">
          <input placeholder="Имя" v-model="registrationName" />
        </div>
      </div>
      <div class="d2">
        <p>Отчество</p>
        <div class="text-box">
          <input placeholder="Отчество" v-model="registerAFather" />
        </div>
      </div>
      <div class="d2 d3">
        <p>Фамилия</p>
        <div class="text-box">
          <input placeholder="Фамилия" v-model="registeredSurname" />
        </div>
      </div>
      <div class="d2" style="margin-bottom: 20px">
        <p>Тел.2</p>
        <div class="text-box">
          <input placeholder="Тел.2" v-model="registrationPhone_2" />
        </div>
      </div>
      <div class="d2">
        <p>Email</p>
        <div class="text-box">
          <input placeholder="Email" v-model="registerEMail" />
        </div>
      </div>
      <div class="message">
        <p>Провинция</p>
        <div class="text-box">
          <input placeholder="Провинция" v-model="registeredProvince" />
        </div>
      </div>
      <div class="message d3">
        <p>Город <span style="color: red">*</span></p>
        <div class="text-box">
          <input placeholder="Город" v-model="registeredCity" />
        </div>
      </div>
      <div class="message">
        <p>Улица</p>
        <div class="text-box">
          <input placeholder="Улица" v-model="registeredStreet" />
        </div>
      </div>
      <div class="message d3">
        <p>Компания</p>
        <div class="text-box">
          <input placeholder="Компания" v-model="registeredCompany" />
        </div>
      </div>
      <div class="d2">
        <div class="biaoqian">
          <img src="../assets/images/zhuce_iocn_VK.png" alt="" /><span>VK</span>
        </div>
        <div class="text-box">
          <input placeholder="входить" v-model="registerVk" />
        </div>
      </div>
      <div class="d2">
        <div class="biaoqian">
          <img src="../assets/images/zhuce_iocn_Whatsapp.png" alt="" /><span
            >WhatsApp</span
          >
        </div>
        <div class="text-box">
          <input placeholder="входить" v-model="registerWhatsApp" />
        </div>
      </div>
      <div class="d2 d3">
        <div class="biaoqian">
          <img src="../assets/images/zhuce_iocn_viber.png" alt="" /><span
            >Viber</span
          >
        </div>
        <div class="text-box">
          <input placeholder="входить" v-model="registerViber" />
        </div>
      </div>
      <div class="button">
        <el-button
          type="warning"
          size="medium"
          :loading="false"
          @click="register"
          >представление</el-button
        >
      </div>
      <p class="already">
        Существующий аккаунт，<span @click="goOn">Вход пароля ></span>
      </p>
      <!-- <p class="features"> -->
      <!-- <div class="features"> -->
      <!-- </div> -->
      <!-- </p> -->
      <!-- <el-button type="warning">警告按钮</el-button> -->
    </el-dialog>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //数据
    return {
      name: "",
      dialogTableVisible: false, //登录弹窗
      forgotVisible: false, //忘记密码弹窗
      registered: false, //注册弹窗
      phoneNumber_1: "", //手机号
      phoneNumber_2: "",
      phoneNumber_3: "",
      phone: "7",
      password: "", //登陆-弹窗-密码
      retrievePasswordCode: "", //找回密码-弹窗-验证码
      pleaseEnterTheLoginPassword: "", //找回密码-弹窗-登陆密码
      retrieveThePasswordAgain: "", //找回密码-弹窗-再次输入密码
      registerVerificationCode: "", //用户注册-弹窗-验证码
      signUpPassword: "", //用户注册-弹窗-登陆密码
      registerAgain: "", //用户注册-弹窗-再次输入密码
      registrationName: "", //用户注册-弹窗-名字
      registerAFather: "", //用户注册-弹窗-父姓
      registeredSurname: "", //用户注册-弹窗-姓氏
      registrationPhone_2: "", //用户注册-弹窗-电话2
      registerEMail: "", //用户注册-弹窗-邮箱
      registeredProvince: "", //用户注册-弹窗-省份
      registeredCity: "", //用户注册-弹窗-城市
      registeredStreet: "", //用户注册-弹窗-街道
      registeredCompany: "", //用户注册-弹窗-公司
      registerVk: "", //用户注册-弹窗-VK
      registerWhatsApp: "", //用户注册-弹窗-WhatsApp
      registerViber: "", //用户注册-弹窗Viber
      retrieve: true,
      retrieve_2: true,
      secondCode: 60, //验证码倒计时
      secondCode_2: 60,
      timer: null,
      timer_2: null,
      total_num: "", //总数
      shuru: true,
      search: "", //搜索内容
      index: 0,
    };
  },
  props: {
    status: {
      type: Boolean,
    },
  },
  //计算属性
  computed: {},
  //监控data中的数据变化
  watch: {
    search(val) {
      this.$store.commit("setSearch", val);
    },

    phoneNumber_1(nal, oal) {
      // console.log(nal);

      if (nal.length > this.index) {
        if (nal[0] == "7") {
          this.phoneNumber_1 = "";
        }
        for (let index = 0; index <= this.phoneNumber_1.length; index++) {
          if (index == 0 && nal[index] != "(") {
            this.phoneNumber_1 = "(" + nal;
          } else if (index == 4 && nal[index] != ")") {
            this.phoneNumber_1 = this.insertStr(this.phoneNumber_1, index, ")");
          } else if (index == 8 && nal[index] != "-") {
            this.phoneNumber_1 = this.insertStr(this.phoneNumber_1, index, "-");
          } else if (index == 11 && nal[index] != "-") {
            this.phoneNumber_1 = this.insertStr(this.phoneNumber_1, index, "-");
          }
        }
        this.index = nal.length;
      } else {
        if (
          nal.length == 1 ||
          nal.length == 5 ||
          nal.length == 9 ||
          nal.length == 12
        ) {
          this.phoneNumber_1 = this.phoneNumber_1.substring(
            0,
            this.phoneNumber_1.length - 1
          );
        }
        this.index = this.phoneNumber_1.length;
      }
      if (this.phoneNumber_1.length == 14) {
        let a = this.phoneNumber_1.split("-");
        let b = "";
        for (let index = 0; index < a.length; index++) {
          b = b + a[index];
        }
        let c = b.split("(");
        let d = c[0] + c[1];
        let e = d.split(")");
        this.phone = "7" + e[0] + e[1];
      }
      // console.log(this.phone);
    },
    phoneNumber_2(nal, oal) {
      // console.log(nal);

      if (nal.length > this.index) {
        if (nal[0] == "7") {
          this.phoneNumber_2 = "";
        }
        for (let index = 0; index <= this.phoneNumber_2.length; index++) {
          if (index == 0 && nal[index] != "(") {
            this.phoneNumber_2 = "(" + nal;
          } else if (index == 4 && nal[index] != ")") {
            this.phoneNumber_2 = this.insertStr(this.phoneNumber_2, index, ")");
          } else if (index == 8 && nal[index] != "-") {
            this.phoneNumber_2 = this.insertStr(this.phoneNumber_2, index, "-");
          } else if (index == 11 && nal[index] != "-") {
            this.phoneNumber_2 = this.insertStr(this.phoneNumber_2, index, "-");
          }
        }
        this.index = nal.length;
      } else {
        if (
          nal.length == 1 ||
          nal.length == 5 ||
          nal.length == 9 ||
          nal.length == 12
        ) {
          this.phoneNumber_2 = this.phoneNumber_2.substring(
            0,
            this.phoneNumber_2.length - 1
          );
        }
        this.index = this.phoneNumber_2.length;
      }
      if (this.phoneNumber_2.length == 14) {
        let a = this.phoneNumber_2.split("-");
        let b = "";
        for (let index = 0; index < a.length; index++) {
          b = b + a[index];
        }
        let c = b.split("(");
        let d = c[0] + c[1];
        let e = d.split(")");
        this.phone = "7" + e[0] + e[1];
      }
      // console.log(this.phone);
    },
    phoneNumber_3(nal, oal) {
      // console.log(nal);

      if (nal.length > this.index) {
        if (nal[0] == "7") {
          this.phoneNumber_3 = "";
        }
        for (let index = 0; index <= this.phoneNumber_3.length; index++) {
          if (index == 0 && nal[index] != "(") {
            this.phoneNumber_3 = "(" + nal;
          } else if (index == 4 && nal[index] != ")") {
            this.phoneNumber_3 = this.insertStr(this.phoneNumber_3, index, ")");
          } else if (index == 8 && nal[index] != "-") {
            this.phoneNumber_3 = this.insertStr(this.phoneNumber_3, index, "-");
          } else if (index == 11 && nal[index] != "-") {
            this.phoneNumber_3 = this.insertStr(this.phoneNumber_3, index, "-");
          }
        }
        this.index = nal.length;
      } else {
        if (
          nal.length == 1 ||
          nal.length == 5 ||
          nal.length == 9 ||
          nal.length == 12
        ) {
          this.phoneNumber_3 = this.phoneNumber_3.substring(
            0,
            this.phoneNumber_3.length - 1
          );
        }
        this.index = this.phoneNumber_3.length;
      }
      if (this.phoneNumber_3.length == 14) {
        let a = this.phoneNumber_3.split("-");
        let b = "";
        for (let index = 0; index < a.length; index++) {
          b = b + a[index];
        }
        let c = b.split("(");
        let d = c[0] + c[1];
        let e = d.split(")");
        this.phone = "7" + e[0] + e[1];
      }
      // console.log(this.phone);
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if (this.$store.state.search) {
      this.search = this.$store.state.search;
    }
    this.name = localStorage.getItem("name");

    this.doCount();
  },
  //方法集合
  methods: {
    /**
     * 指定位置插入字符串
     * @param {String} soure 传入的字符串
     * @param {int} start 传入的下标
     * @param {String} newStr 插入的字符串
     * @returns 插入后的字符串
     */
    insertStr(soure, start, newStr) {
      return soure.slice(0, start) + newStr + soure.slice(start);
    },
    searchFor() {
      if (this.status) {
        this.$parent.ItemList();
      } else {
        this.$store.commit("setSearch", this.search);
        this.$router.push({
          name: "CommodityIndex",
        });
      }
    },
    jianting() {
      // console.log("删除了");
      this.shuru = false;
    },
    open() {
      this.$confirm("Выход ？", "Выход", {
        confirmButtonText: "Да",
        cancelButtonText: "Нет",
        type: "warning",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "Выход.",
          });
          this.name = null;
          localStorage.clear();
          this.$router.push({
            path: "/",
          });
        })
        .catch(() => {});
    },
    goHref(i) {
      if (i == 1) {
        this.$router.push({
          path: "/",
        });
      } else {
        this.$router.push({
          path: "/catIndex",
        });
      }
    },
    //获取购物车统计
    doCount() {
      if (localStorage.getItem("token")) {
        this.api
          .doCount({ token: localStorage.getItem("token") })
          .then((res) => {
            // console.log(res);
            if (res.status == 401) {
              this.name = "";
            }
            this.total_num = res.data.total_num;
          });
      }
    },
    //登录
    login() {
      let data = {
        mobile: this.phone,
        password: this.password,
      };
      this.api.login(data).then((res) => {
        // console.log(res);
        // this.$message(res.info);
        this.Toast(res);
        if (res.status == 1) {
          this.dialogTableVisible = false;
          localStorage.setItem("name", res.data.name);
          localStorage.setItem("token", res.data.token);
          this.name = res.data.name;
          this.doCount();
          clearInterval(this.timer_2);
          this.secondCode_2 = 60;
        }
      });
    },
    //注册
    register() {
      let data = {
        mobile: this.phone,
        password: this.signUpPassword,
        repassword: this.registerAgain,
        sms_code: this.registerVerificationCode,
        name: this.registrationName,
        father_name: this.registerAFather,
        surname: this.registeredSurname,
        mobile2: this.registrationPhone_2,
        vk: this.registerVk,
        whatsapp: this.registerWhatsApp,
        viber: this.registerViber,
        province: this.registeredProvince,
        city: this.registeredCity,
        street: this.registeredStreet,
        business: this.registeredCompany,
        email: this.registerEMail,
      };
      this.api.register(data).then((res) => {
        this.Toast(res);
        if (res.status == 1) {
          clearInterval(this.timer);
          this.secondCode = 60;
          this.registered = false;
          setTimeout(() => {
            this.dialogTableVisible = true;
          }, 200);
          this.phone = "";
          this.signUpPassword = "";
          this.registerAgain = "";
          this.registerVerificationCode = "";
          this.registrationName = "";
          this.registerAFather = "";
          this.registeredSurname = "";
          this.registrationPhone_2 = "";
          this.registerVk = "";
          this.registerWhatsApp = "";
          this.registerViber = "";
          this.registeredProvince = "";
          this.registeredCity = "";
          this.registeredStreet = "";
          this.registeredCompany = "";
          this.registerEMail = "";
          this.phoneNumber_3 = "";
        }
      });
    },
    //确定修改密码
    determineModification() {
      let data = {
        mobile: this.phone,
        sms_code: this.retrievePasswordCode,
        password: this.pleaseEnterTheLoginPassword,
        repassword: this.retrieveThePasswordAgain,
      };
      this.api.forgetPwd(data).then((res) => {
        this.Toast(res);
        this.password = "";
        if (res.status == 1) {
          this.forgotVisible = false;
          setTimeout(() => {
            this.dialogTableVisible = true;
          }, 300);
        }
      });
    },
    //获取验证码
    smsCode(j, i) {
      let data = {
        mobile: this.phone,
        type: i,
      };
      this.api.smsCode(data).then((res) => {
        // console.log(res);
        this.Toast(res);
        if (res.status == 1) {
          console.log(j);
          if (j == 1 && this.retrieve) {
            this.retrieve = false;
            this.timer = setInterval(() => {
              console.log(this.secondCode);
              this.secondCode -= 1;
              if (this.secondCode <= 0) {
                this.retrieve = true;
                this.secondCode = 60;
                clearInterval(this.timer);
              }
            }, 1000);
          } else if (this.retrieve_2) {
            this.retrieve_2 = false;
            this.timer_2 = setInterval(() => {
              this.secondCode_2 -= 1;
              if (this.secondCode_2 <= 0) {
                this.retrieve_2 = true;
                this.secondCode_2 = 60;
                clearInterval(this.timer_2);
              }
            }, 1000);
          }
        }
      });
    },
    handleChange(value) {
      // console.log(value);
    },

    /**
     * @param {int} index 传入的下标
     */
    popUps(index) {
      // console.log(index);
      switch (index) {
        case 0:
          this.dialogTableVisible = true;
          break;
        case 1:
          this.registered = true;
          break;
        case 2:
          this.$router.push({
            path: "/orderIndex",
          });
          break;
        case 3:
          this.$router.push({
            path: "/personalCenter",
          });
          break;
      }
    },

    /**
     * 去登陆
     */
    goOn() {
      this.registered = false;
      setTimeout(() => {
        this.dialogTableVisible = true;
      }, 300);
    },

    /**
     * 忘记密码
     */
    forgotPassword() {
      this.dialogTableVisible = false;
      setTimeout(() => {
        this.forgotVisible = true;
      }, 300);
    },

    /**
     * 返回登陆
     */
    returnToLogin() {
      this.forgotVisible = false;
      setTimeout(() => {
        this.dialogTableVisible = true;
      }, 300);
    },

    /**
     * 注册账号弹窗
     */
    registeredFun() {
      this.dialogTableVisible = false;
      setTimeout(() => {
        this.registered = true;
      }, 300);
    },

    /**
     * 检测登录状态，在顶部显示用户名称，和跳转逻辑。
     * 没有登录点击弹窗，已经登录不进行跳转
     */
    detectionLogin() {},
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    window.addEventListener("storage", (e) => {
      // console.log(e);
      if (e.key == "name" && e.newValue) {
        this.name = e.newValue; //即可获取到【页面A】最新的socketQuery
      }
    });
  },
  //生命周期 - 创建之前
  beforeCreate() {},
  //生命周期 - 挂载之前
  beforeMount() {},
  //生命周期 - 更新之前
  beforeUpdate() {},
  //生命周期 - 更新之后
  updated() {},
  //生命周期 - 销毁之前
  beforeDestroy() {},
  //生命周期 - 销毁完成
  destroyed() {},
  //如果页面有keep-alive缓存功能，这个函数会触发
  activated() {},
};
</script>
<style lang="less" scoped>
//@import url(); 引入公共css类
/deep/.el-input {
  width: 100%;
  height: 100%;
  left: 0;
  position: absolute;
  padding-left: 40px;
}

/deep/.login {
  min-width: 600px;
  // height: 500px !important;
}

/deep/.el-input__icon {
  color: #000;
}

.header {
  // position: fixed;
  // background: #ffffff !important;
  // z-index: 99;
  height: 120px;

  .fiex {
    height: 120px;
    left: 0;
    right: 0;
    z-index: 99;
    margin: 0 auto;
    width: 100%;
    min-width: 1200px;
    background: #ffffff;
    // padding: 0 20px;
    padding-bottom: 20px;
    position: fixed;
  }
}

/deep/.registered .el-dialog {
  // /deep/ {
  margin-top: 5vh !important;

  // }
  .el-dialog__body {
    padding-bottom: 0px;
    padding-top: 4px;

    .title {
      margin: 0px;
      margin-bottom: 30px;
      font-size: 22px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 29px;
      color: #333333;
      opacity: 1;
    }

    .message {
      display: inline-block;
      width: 300px !important;
      position: relative;
      margin-right: 60px;

      p {
        text-align: left;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 16px;
        color: #333333;
        opacity: 1;
        margin-bottom: 10px;
      }

      input {
        padding-left: 12px;
      }
    }

    .d3 {
      margin-right: 0px !important;
    }

    .d2 {
      display: inline-block;
      width: 200px !important;
      position: relative;
      margin-right: 30px;

      p {
        text-align: left;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 16px;
        color: #333333;
        opacity: 1;
        margin-bottom: 10px;
      }

      .text-box {
        width: 100%;
        display: inline-block;
        // width: 300px;
        background: #ffffff;
        border: 1px solid #cecece;
        opacity: 1;
        border-radius: 4px;
        margin-bottom: 15px;
        position: relative;
        line-height: 40px;

        .qi {
          vertical-align: middle;
          display: inline-block;
          // padding-top: 2px;
          color: #888;
          margin-left: 3px;
          // position: relative;
        }

        .duanxin {
          line-height: 44px;
          position: absolute;
          cursor: pointer;
          right: 12px;
        }

        input {
          height: 100%;
          width: 100%;
          padding-left: 12px;
          border: none;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          opacity: 1;
        }

        input::-webkit-input-placeholder {
          color: #cecece;
          font-size: 14px;
        }
      }

      .biaoqian {
        height: 16px;
        margin-bottom: 10px;

        img {
          width: 16px;
          height: 16px;
          opacity: 1;
          margin-right: 6px;
        }

        span {
          font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 16px;
          color: #333333;
          opacity: 1;
        }
      }
    }

    .text-box {
      width: 300px;
      display: inline-block;
      width: 300px;
      line-height: 40px;
      background: #ffffff;
      border: 1px solid #cecece;
      opacity: 1;
      border-radius: 4px;
      position: relative;

      .jia {
        position: relative;
        color: #888;
      }

      .qi {
        vertical-align: middle;
        display: inline-block;
        height: 42px;
        line-height: 42px;
        // padding-top: 2px;
        color: #888;
        margin-left: 3px;
        position: relative;
        vertical-align: top;
      }

      .duanxin {
        line-height: 44px;
        position: absolute;
        cursor: pointer;
        right: 12px;
      }

      .asterisk {
        color: red;
        line-height: 44px;
        position: absolute;
        right: 10px;
      }

      // span {
      //   line-height: 44px;
      //   position: absolute;
      //   right: 12px;
      // }
    }

    .t1 {
      margin-right: 60px;
    }

    .button {
      margin-bottom: 12px;
    }

    .already {
      text-align: center;
      color: #999999;
      margin-bottom: 20px;

      span {
        color: #e9ad61;
        cursor: pointer;
      }
    }
  }
}

/deep/.forgot .el-dialog__body {
  padding-top: 36px;

  .title {
    margin: 0;
    margin-bottom: 40px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    line-height: 24px;
    color: #333333;
    opacity: 1;
  }

  .text-box {
    position: relative;

    .qi {
      vertical-align: middle;
      display: inline-block;
      // padding-top: 2px;
      color: #888;
      margin-left: 3px;
      position: relative;
    }

    .asterisk {
      line-height: 44px;
      position: absolute;
      cursor: pointer;
      right: 12px;
    }

    .duanxin {
      line-height: 44px;
      position: absolute;
      cursor: pointer;
      right: 12px;
    }
  }

  .left {
    display: block;
    width: 100%;
    color: #e9ad61;
    cursor: pointer;
    text-align: center;
  }
}

/deep/ .el-dialog__body {
  text-align: left !important;
  text-align: center;
  padding: 12px 120px 0 120px;
  overflow: hidden;
  padding-bottom: 66px;

  .block {
    display: inline-block;
    width: 300px;
    background: #ffffff;
    opacity: 1;
    border-radius: 4px;
    position: relative;
    margin-bottom: 20px;

    p {
      text-align: left;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 16px;
      color: #333333;
      opacity: 1;
      margin-bottom: 10px;
    }

    .el-cascader {
      width: 100%;
    }

    .el-input__inner {
      height: 42px;
    }
  }

  .logo {
    // width: 100%;
    height: 66px;
    position: relative;
    margin: 0 auto;
    display: block;
  }

  .title {
    text-align: center;
    font-size: 22px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 29px;
    margin: 35px 0;
    color: #e9ad61;
    opacity: 1;
  }

  .text-box {
    .qi {
      vertical-align: middle;
      display: inline-block;
      // padding-top: 2px;
      color: #888;
      margin-left: -3px;
    }

    text-align: left;
    width: 100%;
    height: 44px;
    background: #ffffff;
    border: 1px solid #cecece;
    opacity: 1;
    border-radius: 4px;
    line-height: 40px;
    margin-bottom: 15px;
    position: relative;
    overflow: hidden;

    // padding: ;
    img {
      width: 24px;
      height: 24px;
      float: left;
      margin: 10px 10px 10px 12px;
    }

    input {
      height: 100%;
      width: 309px !important;
      position: absolute;
      border: none;
      // padding-right: 46px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      opacity: 1;
      padding-left: 5px;
    }

    span {
      cursor: pointer;
    }

    input::-webkit-input-placeholder {
      color: #cecece;
      font-size: 14px;
    }
  }

  .button {
    width: 100%;
    text-align: center;

    .el-button {
      margin-top: 10px;
      width: 360px;
      height: 44px;
      background: #edc18a;
      border-color: #edc18a;
      opacity: 1;
      border-radius: 4px;
      margin-bottom: 20px;

      span {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 17px;
        color: #ffffff;
        opacity: 1;
      }
    }

    .el-button:hover {
      background: #fdc18a;
    }
  }

  // .features {
  //   position: relative;
  //   overflow: hidden;
  span {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 19px;
    color: #e9ad61;
    opacity: 1;
  }

  .left {
    cursor: pointer;
    float: left;
    // left: 0;
  }

  .right {
    /* float: right; */
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 19px;
    text-align: center;
    cursor: pointer;
    color: #e9ad61;
    // right: 0;
  }
}

// }
html {
  min-width: 1200px;
}

.box {
  padding: 0;
  height: 120px;

  &-all {
    max-width: 1200px;
    // min-width: 1200px;
    height: 100%;
    width: 100%;
    margin: 0 auto !important;
    position: relative;

    .title {
      padding-top: 18px;
      position: absolute;
      z-index: 2;
      width: 100%;
      text-align: right;
      cursor: pointer;

      span {
        margin-left: 30px;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        opacity: 1;
      }

      .active {
        color: #e9ad61;
      }
    }

    .searching-feature {
      position: absolute;
      float: left;
      width: 100%;
      bottom: 0;
      bottom: 0;

      .logo {
        width: 217px;
        height: 65px;
        object-fit: cover;
      }

      .search-for {
        margin-left: 240px;
        display: inline-block;
        width: 532px;
        position: relative;
        height: 38px;
        background: #ffffff;
        border: 1px solid #edc18a;
        opacity: 1;
        border-radius: 100px;
        position: relative;

        // top: 20px;
        // float: left;
        .search-icon {
          display: inline-block;
          height: 100%;
          position: relative;
        }

        img {
          margin: 10px 8px 0 16px;
          float: left;
          position: relative;
          width: 16px;
          height: 16px;
        }

        .search-input-box {
          float: left;
          // display: inline-block;
          width: 400px;
          height: 100%;
          margin: 0;
        }

        .search-input-box {
          input {
            position: relative;
            height: 100%;
            width: 100%;
            border: none;
            font-size: 14px;
            font-weight: 400;
            color: #333;
            margin: 0;
          }

          input::-webkit-input-placeholder {
            color: #c5c5c5 !important;
            font-size: 14px;
            font-weight: 400;
            line-height: 36px;
          }
        }

        // .search-input-box input[placeholder] {
        //   font-size: 14px;
        //   font-family: Microsoft YaHei;
        //   font-weight: 400;
        //   line-height: 19px;
        //   color: red;
        // }
        .search-button {
          // display: inline-block;
          float: right;
          width: 90px;
          height: 100%;
          background: #edc18a;
          opacity: 1;
          border-radius: 0px 19px 19px 0px;
          text-align: center;
          cursor: pointer;
        }

        .search-button span {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 21px;
          color: #ffffff;
          line-height: 37px;
          opacity: 1;
        }
      }

      .shopping-cart {
        // padding: 0 22px;
        text-align: center;

        // display: inline-block;
        float: right;
        width: 134px;
        height: 38px;
        background: #ffffff;
        border: 1px solid #edc18a;
        opacity: 1;
        border-radius: 19px;
        cursor: pointer;
        position: relative;
        top: 27px;

        .shopping-cart-button {
          img {
            top: 5px;
            width: 20px;
            height: 20px;
            position: relative;
            margin: auto 0;
            margin-right: 10px;
          }

          span {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 38px;
            color: #edc18a;
            opacity: 1;
          }
        }

        .unread-number {
          top: -20%;
          right: -10px;
          display: block;
          padding: 0 5px;
          position: absolute;
          height: 18px;
          background: #ff3939;
          border: 1px solid #ffffff;
          opacity: 1;
          border-radius: 11px;
          font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          // line-height: 16px;
          color: #ffffff;
          opacity: 1;
        }
      }
    }
  }
}
</style>